export default __webpack_public_path__ + "static/size-7-738f7201e1315c5f07944f8d1477554e.png";